import { useEffect, useState } from 'react'
import { Modal, Button, Col } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { editButton, getButtonById } from '../../../../API/Buttons/Buttons'
import { SingleButton } from '../../../../API/Buttons/models'

interface Props {
    show: boolean
    onHide: () => void
    selectedButton: SingleButton | null
}



export const EditButtonModal = ({ show, onHide, selectedButton }: Props) => {
    const [form, setForm] = useState({
        category: 'bienvenida',
        name: ''
    })


    const handleSave = async () => {
        if (!form.name) {
            toast.error('El nombre no puede estar vacío')
            return
        }

        const response = await editButton({ buttonId: selectedButton?.id ?? '', name: form.name, category: form.category })


        if (response === 'done') {
            toast.success('Botón editado correctamente')
            onHide()
        } else {
            const errorMessage = response?.response?.data?.msg ?? 'Error al editar el botón'
            toast.error(errorMessage)
        }


    }

    const fetchButton = async () => {
        const res = await getButtonById(selectedButton?.id ?? '')
        if (res) {
            console.log(res)
            setForm({
                category: res.category,
                name: res.name
            })
        }
    }

    useEffect(() => {
        fetchButton()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedButton])

    return (
        <Modal show={show} onHide={onHide} size='lg' centered>
            <Modal.Header closeButton>

                <Modal.Title>Editar Botón "{selectedButton?.name}"</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column gap-2 p-3'>

                    <div>
                        <Col md={12} sm={12}>

                            <div className='gap-2'>
                                <label htmlFor='text' className='text-primary text-xs'>
                                    Nuevo Nombre
                                </label>
                            </div>
                            <input className='form-control' value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />

                        </Col>
                    </div>
                    <div>
                        <Col md={12} sm={12}>

                            <div className='gap-2'>
                                <label htmlFor='text' className='text-primary text-xs'>
                                    Nueva Categoría
                                </label>
                            </div>
                            <select className='form-control' value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>

                                <option value='bienvenida'>Bienvenida</option>
                                <option value='info'>Info</option>
                                <option value='premios'>Premios</option>
                                <option value='fichas'>Fichas</option>
                                <option value='extra'>Extras</option>

                            </select>
                        </Col>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
                <Button variant="primary" onClick={() => {
                    handleSave()
                }}>
                    Editar
                </Button>



            </Modal.Footer>
        </Modal>
    )
}
